// extracted by mini-css-extract-plugin
export default {"grid":"E_4RvqyI4YXyPCH1OgK6e"};